import { DropdownItem } from "@atlaskit/dropdown-menu";
import Lozenge from "@atlaskit/lozenge-next";

import { getStatusColor } from "@/components/fastshift/src/common/utils";
import { FastshiftRollUpStatus } from "@/libraries/bxp-web-stargate-client/src";

import { FilterOption } from "../../../types";

export const StatusFilterDropdownItem = ({
    option,
    isSelected,
    onStatusChange,
    sendStatusFilterDropdownItemClickUIEvent
}: {
    option: FilterOption<FastshiftRollUpStatus>;
    isSelected: boolean;
    onStatusChange: (option: FilterOption<FastshiftRollUpStatus>) => void;
    sendStatusFilterDropdownItemClickUIEvent: (selectedStatus: string) => void;
}) => {
    return (
        <DropdownItem
            key={option.value}
            onClick={() => {
                sendStatusFilterDropdownItemClickUIEvent(option.value);
                onStatusChange(option);
            }}
            isSelected={isSelected}
        >
            <Lozenge appearance={getStatusColor(option.value)}>
                {option.label}
            </Lozenge>
        </DropdownItem>
    );
};
